import { citySchema } from 'shared/components/vxl/input/schemas/city.schema';
import { usStateSchema } from 'shared/components/vxl/input/schemas/usState.schema';
import { zipCodeSchema } from 'shared/components/vxl/input/schemas/zipCode.schema';
import { z } from 'zod';

import { streetAddressLineOneSchema } from './streetAddressLineOne.schema';
import { streetAddressLineTwoSchema } from './streetAddressLineTwo.schema';

export const addressSchema = z.object({
  addressLine1: streetAddressLineOneSchema,
  addressLine2: streetAddressLineTwoSchema,
  city: citySchema,
  state: usStateSchema,
  zip: zipCodeSchema,
});
